import * as React from 'react';
import { RenderDiv } from 'source/app/presentation/Shared/Render';
import * as styles from 'source/app/presentation/MainPanel/Workflows/SearchNodes/SearchNodes.css';

export function SearchWarning({ children, when }: { children: any; when: boolean; }) {
	// This needs to be removed as it is not being used
	return (
		<RenderDiv
			id="searchWarning"
			when={when}
			withClasses={styles.searchWarning}
		>
			{children}
		</RenderDiv>
	);
}
